import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { NavButton, InscriptionButton } from '../Buttons';
import { Box } from '@material-ui/core';
import {
	scrollToInformation,
	scrollToProgram,
	scrollToDirection,
	scrollToOpinions,
	scrollToContact
} from '../../modules/home/actions';
import Header from './index';

const HomeHeader = props => {
	const { t } = useTranslation();

	return (
		<Header>
			<NavButton
				content={t('general.menu.information')}
				onClick={props.scrollToInformation}
			/>
			<NavButton
				content={t('general.menu.program')}
				onClick={props.scrollToProgram}
			/>
			<NavButton
				content={t('general.menu.staff')}
				onClick={props.scrollToDirection}
			/>
			<NavButton
				content={t('general.menu.opinions')}
				onClick={props.scrollToOpinions}
			/>
			<NavButton
				content={t('general.menu.contact')}
				onClick={props.scrollToContact}
			/>
			<Box className="inscriptionButton">
				<InscriptionButton />
			</Box>
		</Header>
	);
};

const mapDispatchToProps = dispatch => {
	return {
		scrollToInformation: payload => scrollToInformation(dispatch, payload),
		scrollToProgram: payload => scrollToProgram(dispatch, payload),
		scrollToDirection: payload => scrollToDirection(dispatch, payload),
		scrollToOpinions: payload => scrollToOpinions(dispatch, payload),
		scrollToContact: payload => scrollToContact(dispatch, payload)
	};
};

export default connect(null, mapDispatchToProps)(HomeHeader);
